/*
 *
 * Do not edit directly
 * Generated on Mon, 24 Jun 2024 16:18:26 GMT
 *
 */


const theme = {
  appearances: {},
  rules: [],
  tokens: {
    rangeBackground: 'rgba(0, 0, 0, 0)',
    thumbBackground: '#ffffff',
    thumbHeight: 8,
    thumbWidth: 8,
    timestampMarginLeft: 8,
    timestampMarginRight: 8,
    trackGradientEnd: '#66cc00',
    trackGradientStart: '#66cc00'
  }
}
export default theme
